<template>
<div id="trafico-transporte">

    <v-form ref="form" lazy-validation>
        <div class="row">
            <div class="col-xs-1">
                <v-btn fab dark x-small color="green" v-on:click="addNew" title="Agregar" v-tippy>
                    <v-icon dark>add</v-icon>
                </v-btn>
            </div>
            <div class="col-xs-10"></div>
        </div>
        <div v-for="(transporte, index) in this.$store.state.transportes_trafico" v-bind:key="index" @keyup.enter="nextTab">
             <v-row  style="flex-wrap: nowrap;">
                <v-col cols="3" class="flex-grow-0 flex-shrink-0">
                         <v-autocomplete v-model="transporte.transportista" :items="transportistas" :hide-no-data="true" item-text="metadato" item-value="metadato" label="Seleccione el Transportista" @input="setRFC(transporte.transportista, index)"></v-autocomplete>
             
                </v-col>
                <v-col cols="2" class="flex-grow-1 flex-shrink-0">
                        <v-text-field :name="'rfc['+index+']'" label="RFC o TAX ID" type="text" autocomplete="off" v-model="transporte.rfc" :rules="[rules.required]"></v-text-field>

                </v-col>
                <v-col cols="3" class="flex-grow-0 flex-shrink-1">

                       <v-combobox v-model="transporte.ruta_origen" :items="ciudades" :hide-no-data="true" item-text="nombre" item-value="nombre" label="Seleccione el Origen" @input="cargarTarifa(transporte.ruta_origen, transporte.ruta_destino, index)" :rules="[rules.required]" />

                </v-col>
                <v-col cols="3" class="flex-grow-0 flex-shrink-1">
                   
                    <v-combobox v-model="transporte.ruta_destino" :items="ciudades" :hide-no-data="true" item-text="nombre" item-value="nombre" label="Seleccione el Destino" @input="cargarTarifa(transporte.ruta_origen, transporte.ruta_destino, index)" :rules="[rules.required]" />

                </v-col>
                 <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                   
                     <v-text-field :name="'tarifa['+index+']'" label="Tarifa" type="text" autocomplete="off" class="right-input" v-model="transporte.tarifa" :rules="[ rules.number]"></v-text-field>

                </v-col>
                 <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                   
                    <v-btn fab dark x-small color="red" v-on:click="remove(index)" title="Eliminar" v-tippy>
                        <v-icon dark>remove</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
          

        </div>

    </v-form>

    <p />
    <p />
    <p />

</div>
</template>

<script>
import Vue from "vue";

import {
    request
} from 'http';
import {
    mapState
} from 'vuex'
import axios from "axios";

export default {
    components: {

    },
    mounted: function () {

    },
    created: function () {
        this.URL = this.$hostname + 'traficos/';
        this.cargarTransportistas();
        this.cargarCiudades();
        this.cargar();
        this.formUpdated = false;
        this.$watch('transportes_trafico', this.formChanged, {
            deep: true
        });

        // if(this.$store.state.transportes_trafico.length == 0)
        //   this.$store.state.transportes_trafico.push(Vue.util.extend({}, this.transporte));

    },
    beforeDestroy: function () {
        this.transportes = [];
        this.$store.state.transportes_trafico = [];
    },
    computed: mapState([
        // map this.count to store.state.count
        'transportes_trafico'
    ]),
    methods: {
        nextTab() {
            this.$emit('nextTab', 4);
        },
        addNew: function () {
            // this.embarques.push(Vue.util.extend({}, this.embarque));
            this.$store.state.transportes_trafico.push(Vue.util.extend({}, this.transporte));
        },
        remove: function (index) {
            //  Vue.delete(this.embarques, index);
            Vue.delete(this.$store.state.transportes_trafico, index);
        },
        setRFC: function (transportista, indice) {
            var transportistas = this.transportistas.filter(function (emi) {
                return emi.metadato == transportista;
            });
            this.$store.state.transportes_trafico[indice]['rfc'] = transportistas[0].rfc;

        },

        ///catalogos/transportistas/get_transportistas/
        cargarTransportistas: function () {
            var cliente_id = this.$local_storage.get("id_cliente");
            if (cliente_id > 0) {
                var datos = {
                    cliente: cliente_id,
                };
                axios.post(this.$hostname + 'catalogos/transportistas/get_transportistas/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            this.transportistas = res.data;
                        }
                    })
                    .catch((err) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener los emisores"
                        });
                        console.log(err.response);
                    });
            }

        },
        cargarCiudades: function () {
            var rfc = this.$local_storage.get("rfc");
            var cliente_id = this.$local_storage.get("id_cliente");
            if (cliente_id > 0) {
                var datos = {
                    rfc: rfc,
                };
                axios.post(this.$hostname + 'traficos/obtener_ciudades/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            this.ciudades = res.data;
                        }
                    })
                    .catch((err) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener las ciudades"
                        });
                        console.log(err.response);
                    });
            }

        },
        cargarTarifa: function (origen, destino, indice) {

            var datos = {
                "origen": origen,
                "destino": destino
            };
            if (origen.length > 0 && destino.length > 0) {
                axios.post(this.$hostname + 'traficos/obtener_tarifa/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            if (parseFloat(res.data) == 0)
                                this.$store.state.transportes_trafico[indice]['tarifa'] = "";
                            else
                                this.$store.state.transportes_trafico[indice]['tarifa'] = parseFloat(res.data);
                        }

                    })
                    .catch((err) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener la tarifa"
                        });
                        console.log(err.response);
                    });
            }

        },

        cargar: function () {
            var referencia = this.$local_storage.get("referencia");
            var rfc = this.$local_storage.get("rfc");
            if (referencia != null && referencia.trim() != "") {
                var datos = {
                    rfc: rfc,
                    referencia: referencia
                };
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                axios
                    .post(this.URL + "obtener/", datos)
                    .then((res) => {
                        if (typeof res.data !== "undefined") {
                            this.transportes = res.data.transportes;
                            this.$store.state.transportes_trafico = res.data.transportes;
                            if (res.data.transportes.length == 0)
                                this.addNew();
                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener los registros de transporte"
                            //showConfirmButton: false,
                        });
                        console.log(err.response);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.formUpdated = false;
                    });
            }
        },
        save(resolve) {
            if (this.$refs.form.validate()) {
                if (this.formUpdated == true) {
                    this.$root.$dialogLoader.show('Espere un momento por favor..');
                    const datos = {
                        referencia: this.$local_storage.get("referencia"),
                        rfc: this.$local_storage.get("rfc"),
                        transportes: this.$store.state.transportes_trafico
                    };

                    var metodo = "put";
                    var urlCliente = this.$hostname + "traficos/actualizar/";

                    axios
                        .put(urlCliente, datos, {
                            "Content-type": "application/json",
                            "Access-Control-Allow-Origin": "*",
                            "cache-control": "no-cache"
                        }).then((response) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "Los datos de transporte se guardaron correctamente",
                                footer: ""
                            });
                            this.cargar();
                            this.cargarCiudades();
                            this.$root.$dialogLoader.hide();
                            this.formUpdated = false;
                            resolve(true);
                        })
                        .catch((error) => {
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos de transporte"
                            });
                            this.$root.$dialogLoader.hide();
                            resolve(false);
                        });
                } else
                    resolve(true);

            } else {
                this.$swal({
                    type: "info",
                    title: "Cuidado!",
                    text: 'Datos incompletos en el formulario. Favor de verificar.'
                    //showConfirmButton: false,
                });
                resolve(false);
            }
        },

        formChanged: function (newV, oldV) {
            this.formUpdated = true;
        },

    },
    data: () => ({
        fab: false,
        loading: false,
        show_loading: false,
        URL: "",
        formUpdated: false,
        transportistas: [],
        ciudades: [],
        transporte: {
            transportista: "",
            rfc: "",
            ruta_origen: "",
            ruta_destino: "",
            tarifa: ""
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            number: value => {
                const pattern = /^[\d]*\.?[\d]*$/;
                return pattern.test(value) || "Campo numérico";
            }
        },
        embarques: []
    })
};
</script>
